import {Directive} from '@angular/core';

/* To override a default toggle icon */
@Directive({
    standalone: false,selector: '[ngxMaterialTimepickerToggleIcon]'})

export class NgxMaterialTimepickerToggleIconDirective {
}
